import {logger} from "@/services/logger.service";

let urlParams = new URLSearchParams(window.location.search);
const feature = urlParams.get('feature')
if(feature) {
    logger.info("Features activated: "+ feature.toUpperCase())
    sessionStorage.setItem("feature", feature.toUpperCase())
}

export default {
    //https://cli.vuejs.org/guide/mode-and-env.html
    getEnv() {
        return process.env.NODE_ENV;
    },
    isDevEnv() {
        return this.getEnv() === 'development';
    },
    isDevMockEnv() {
        return this.isDevEnv() && process.env.VUE_APP_API_MOCK_ENABLED === 'true';
    },
    isMockUserAdmin() {
        return process.env.VUE_APP_MOCK_USER_ADMIN === 'true';
    },
    isWiremockLogin() {
        return process.env.VUE_APP_FEATURE_LOGIN_WIREMOCK === 'true';
    },
    isProdEnv() {
        return this.getEnv() === 'production';
    },
    getBaseUrl() {
        return process.env.BASE_URL;
    },
    getApiBaseUrl() {
        return process.env.VUE_APP_API_BASE_URL;
    },
    getLoginBaseUrl() {
        return process.env.VUE_APP_LOGIN_BASE_URL;
    },
    getSwisscomSsoId() {
        return process.env.VUE_APP_LOGIN_SWISSCOM_SSO_ID;
    },
    getOidbSsoId() {
        return process.env.VUE_APP_LOGIN_OIDB_SSO_ID;
    },
    getWiremockSsoId() {
        return process.env.VUE_APP_LOGIN_WIREMOCK_SSO_ID;
    },
    getOAuth2LoginBaseUrl() {
        return process.env.VUE_APP_OAUTH2_LOGIN_BASE_URL;
    },
    getOAuth2LogoutUrl() {
        return process.env.VUE_APP_OAUTH2_LOGOUT_URL;
    },
    getDays4SmsSearch() {
        return Number(process.env.VUE_APP_DAYS_FOR_SMS_SEARCH);
    },
    getEmail4CreateCustomer() {
        return process.env.VUE_APP_EMAIL_CREATE_CUSTOMER;
    },
    getEmail4CreateCustomerCC() {
        return process.env.VUE_APP_EMAIL_CREATE_CUSTOMER_CC;
    },
    featureToggleLogin() {
        return process.env.VUE_APP_FEATURE_LOGIN === 'true' || (sessionStorage.getItem("feature")+"").includes("LOGIN");
    },
    featureToggleStats() {
        return process.env.VUE_APP_FEATURE_STATS === 'true' || (sessionStorage.getItem("feature")+"").includes("STATS");
    },
    featureToggleSmsOutbox() {
        return process.env.VUE_APP_FEATURE_SMSOUTBOX === 'true' || (sessionStorage.getItem("feature")+"").includes("SMSOUTBOX");
    },
    featureToggleSmsInbox() {
        return process.env.VUE_APP_FEATURE_SMSINBOX === 'true' || (sessionStorage.getItem("feature")+"").includes("SMSINBOX");
    },
    featureToggleSendSms() {
        return process.env.VUE_APP_FEATURE_SENDSMS === 'true' || (sessionStorage.getItem("feature")+"").includes("SENDSMS");
    },
    featureToggleCampaign() {
        return process.env.VUE_APP_FEATURE_CAMPAIGNS === 'true' || (sessionStorage.getItem("feature")+"").includes("CAMPAIGN");
    },
    featureToggleCampaignsPreviewSms() {
        return process.env.VUE_APP_FEATURE_CAMPAIGNSPREVIEWSMS === 'true' || (sessionStorage.getItem("feature")+"").includes("CAMPAIGNSPREVIEWSMS");
    },
    featureToggleSmsTag() {
        return process.env.VUE_APP_FEATURE_SMSTAG === 'true' || (sessionStorage.getItem("feature")+"").includes("SMSTAG");
    },
    featureToggleBillingProfile() {
        return process.env.VUE_APP_FEATURE_BILLINGPROFILES === 'true' || (sessionStorage.getItem("feature")+"").includes("BILLINGPROFILES");
    },
    featureToggleBillingProfile4User() {
        return process.env.VUE_APP_FEATURE_BILLINGPROFILES4USER === 'true' || (sessionStorage.getItem("feature")+"").includes("BILLINGPROFILES4USER");
    },
    featureToggleUnicodeDetector() {
        return process.env.VUE_APP_FEATURE_UNICODEDETECTOR === 'true' || (sessionStorage.getItem("feature")+"").includes("UNICODEDETECTOR");
    },
    featureToggleAllowList() {
        return process.env.VUE_APP_FEATURE_ALLOWLIST === 'true' || (sessionStorage.getItem("feature")+"").includes("ALLOWLIST");
    },
    featureToggleDenyList() {
        return process.env.VUE_APP_FEATURE_BLOCKLIST === 'true' || (sessionStorage.getItem("feature")+"").includes("BLOCKLIST");
    },
    featureToggleCostLimit() {
        return process.env.VUE_APP_FEATURE_COSTLIMIT === 'true' || (sessionStorage.getItem("feature")+"").includes("COSTLIMIT");
    },
    featureToggleQuickGuide() {
        return process.env.VUE_APP_FEATURE_QUICKGUIDE === 'true' || (sessionStorage.getItem("feature")+"").includes("QUICKGUIDE");
    },
    featureToggleEmailOutbox() {
        return process.env.VUE_APP_FEATURE_EMAILOUTBOX === 'true' || (sessionStorage.getItem("feature")+"").includes("EMAILOUTBOX");
    },
    featureToggleStatsNew() {
        return process.env.VUE_APP_FEATURE_STATSNEW === 'true' || (sessionStorage.getItem("feature")+"").includes("STATSNEW");
    },
    featureToggleStatsOld() {
        return process.env.VUE_APP_FEATURE_STATSOLD === 'true' || (sessionStorage.getItem("feature")+"").includes("STATSOLD");
    }
};
